import { DownOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Card,
  Dropdown,
  notification,
  Space,
  Table,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getAllExams,
  getDetailsCalendar,
  getDetailsExamenRattrapage,
  getListApprenants,
} from "../../../../api/geoprod";
import { useLoader } from "../../../../context/LoaderContext";
import GlobalContext from "../../../../context/GlobalContext";
import dayjs from "dayjs";
import ModalSaisieNotes from "../SaisieNotes/ModalSaisieNotes/ModalSaisieNotes";

const ListeDesExamensEtRattrapages = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const { setIsLoading } = useLoader();
  const {
    dates,
    setDates,
    setModulesExamens,
    modulesRattrapages,
    setModulesRattrapages,
    setGlobalData,
    setCurrentStep,
  } = useContext(GlobalContext);
  const [openModal, setOpenModal] = useState(false);
  const params = useLocation();
  const [listeApprenants, setListeApprenants] = useState([]);
    const [listeModules, setListeModules] = useState([]);
  const id_affaire = params?.state?.id_affaire;

  const columns = [
    {
      title: t("Période"),
      dataIndex: "periode",
      key: "periode",
    },
    {
      title: t("Date début examen"),
      dataIndex: "date_debut_periode_examen",
      key: "date_debut_periode_examen",
    },
    {
      title: t("Date fin examen"),
      dataIndex: "date_fin_periode_examen",
      key: "date_fin_periode_examen",
    },
    {
      title: t("Date début rattrapage"),
      dataIndex: "date_debut_periode_rattrapage",
      key: "date_debut_periode_rattrapage",
      render: (text) => text || "N'existe pas",
    },
    {
      title: t("Date fin rattrapage"),
      dataIndex: "date_fin_periode_rattrapage",
      key: "date_fin_periode_rattrapage",
      render: (text) => text || "N'existe pas",
    },
    {
      title: t("Actions"),
      key: "actions",
      render: (_, record) => (
        <Space>
          <Dropdown
            menu={{
              items: [
                {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => {
                        setIsLoading(true);
                        getListApprenants("2025-04-07 09:03:07.098")
                          .then((response) => {
                         
                            setListeApprenants(response?.message?.Data);

                            getDetailsCalendar(
                             id_affaire,
                              record?.periode
                            )
                              .then((responseDetailsCalendar) => {
                                
                             const result = Object.values(responseDetailsCalendar.details)[0];
                              setListeModules(result)

                                setIsLoading(false);
                           
                            setIsLoading(false);
                            console.log("response", response);
                            setOpenModal(true);

                              })
                              .catch((error) => {
                                setIsLoading(false);
                                notification?.error({
                                  message: t("Erreur"),
                                  description: t(error?.data?.message),
                                  duration: 0,
                                });
                              });

                        
                          })
                          .catch((error) => {
                            setIsLoading(false);
                            notification?.error({
                              message: t("Erreur"),
                              description: t(error?.data?.message),
                              duration: 0,
                            });
                          });
                      }}
                    >
                      {t("Saisie des notes")}
                    </Button>
                  ),
                },
                    {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => {
                        setIsLoading(true);
                  navigate(
                              "/apprenants/notes",
                              {
                                state: {
                                  periode:record?.periode,
                                  id_affaire:id_affaire
                                },
                              }
                            );
                      }}
                    >
                      {t("Consulter Notes")}
                    </Button>
                  ),
                },
                {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => {
                        setIsLoading(true);

                        getDetailsCalendar(
                          id_affaire,
                          record?.periode
                        )
                          .then((response) => {
                            setIsLoading(false);
                            navigate(
                              "/sessionFormationHomologuee/consulterDetailsCalendrier",
                              {
                                state: {
                                  result: response?.details?.[record?.periode],
                                },
                              }
                            );
                          })
                          .catch((error) => {
                            setIsLoading(false);
                            notification?.error({
                              message: t("Erreur"),
                              description: t(error?.data?.message),
                              duration: 0,
                            });
                          });
                      }}
                    >
                      {t("Consulter Calendrier")}
                    </Button>
                  ),
                },
                {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => {
                        sessionStorage.removeItem("currentStep");
                        setCurrentStep(0);
                        setIsLoading(true);
                        getDetailsExamenRattrapage(id_affaire)
                          .then((response) => {
                            setIsLoading(false);
                            const mappedmodules = response?.existe?.examen.map(
                              (exam) => ({
                                id: exam?.id_module,
                                name: exam?.name_module,
                                id_md: exam?.id,
                              })
                            );
                            const mappedmodulesRattrapage =
                              response?.existe?.rattrapage.map((exam) => ({
                                id: exam?.id_module,
                                name: exam?.name_module,
                                id_md: exam?.id,
                              }));

                            if (
                              mappedmodules.length === 0 &&
                              mappedmodulesRattrapage.length === 0
                            ) {
                              notification.warning({
                                message: t("Vous ne disposez pas"),
                                duration: 0,
                              });
                            } else {
                              let newDates = { ...dates };
                              if (
                                mappedmodulesRattrapage &&
                                response?.existe?.date_debut_rattrapage &&
                                response?.existe?.date_fin_rattrapage
                              ) {
                                newDates.rattrapage = {
                                  startDate: dayjs(
                                    response.existe.date_debut_rattrapage,
                                    "YYYY/MM/DD"
                                  ).format("DD/MM/YYYY"),
                                  endDate: dayjs(
                                    response.existe.date_fin_rattrapage,
                                    "YYYY/MM/DD"
                                  ).format("DD/MM/YYYY"),
                                };
                                setModulesRattrapages(mappedmodulesRattrapage);
                                setDates(newDates);
                              }

                              if (
                                mappedmodules &&
                                response?.existe?.date_debut_examen &&
                                response?.existe?.date_fin_examen
                              ) {
                                newDates.examen = {
                                  startDate: dayjs(
                                    response.existe.date_debut_examen,
                                    "YYYY/MM/DD"
                                  ).format("DD/MM/YYYY"),
                                  endDate: dayjs(
                                    response.existe.date_fin_examen,
                                    "YYYY/MM/DD"
                                  ).format("DD/MM/YYYY"),
                                };
                                setModulesExamens(mappedmodules);
                                setDates(newDates);
                              }

                              const dataToSave = {
                                modulesExamens: mappedmodules,
                                modulesRattrapages: mappedmodulesRattrapage,
                                dates: newDates,
                                periode: response?.existe?.periode,
                                modulesExamensSession: mappedmodules,
                                modulesRattrapagesSession:
                                  mappedmodulesRattrapage,
                                datesSession: dates,
                              };
                              sessionStorage.setItem(
                                "globalData",
                                JSON.stringify(dataToSave)
                              );
                              
                              setGlobalData(dataToSave);
                              navigate(
                                "/sessionFormationHomologuee/calendrierExamensRattrapages",
                                {
                                  state: {
                                    id_calendrier_examen:
                                      record?.id_calendrier_examen ,
                                    id_calendrier_rattrapage:
                                      record?.id_calendrier_rattrapage ,
                                      id_affaire:id_affaire
                                  },
                                }
                              );
                            }
                          })
                          .catch(() => {
                            setIsLoading(false);
                          });
                      }}
                    >
                      {t("Gestion Calendrier")}
                    </Button>
                  ),
                },
              ],
            }}
            trigger={["click"]}
          >
            <span style={{ cursor: "pointer" }}>
              <Space>
                {t("Liste")}
                <DownOutlined />
              </Space>
            </span>
          </Dropdown>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getAllExams(id_affaire)
      .then((response) => {
        const result = response.modules || {};
        const formattedData = [];
        Object.entries(result).forEach(([periode, examens]) => {
          formattedData.push({
            key: periode,
            periode: `${periode}`,
            date_debut_periode_examen: examens.date_debut_periode_examen
              ? dayjs(examens.date_debut_periode_examen, "YYYY/MM/DD").format(
                  "DD/MM/YYYY"
                )
              : "N'existe pas",
            date_fin_periode_examen: examens.date_fin_periode_examen
              ? dayjs(examens.date_fin_periode_examen, "YYYY/MM/DD").format(
                  "DD/MM/YYYY"
                )
              : "N'existe pas",
            date_debut_periode_rattrapage: examens.date_debut_periode_rattrapage
              ? dayjs(
                  examens.date_debut_periode_rattrapage,
                  "YYYY/MM/DD"
                ).format("DD/MM/YYYY")
              : "",
            date_fin_periode_rattrapage: examens.date_fin_periode_rattrapage
              ? dayjs(examens.date_fin_periode_rattrapage, "YYYY/MM/DD").format(
                  "DD/MM/YYYY"
                )
              : "",
               id_calendrier_examen: examens?.id_calendrier_examen,
              id_calendrier_rattrapage: examens?.id_calendrier_rattrapage,
          });
        });

        setData(formattedData);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des examens :", error);
      });
  }, []);

  return (
    <div>
      <Alert
        type="info"
        style={{ marginBlock: "20px" }}
        message="Configuration"
        description={`Liste des examens et des rattrapages`}
        showIcon
      />
      <Card title="Liste des examens et des rattrapages" bordered={false}>
        <Table
          locale={{ emptyText: t("Aucune donnée") }}
          columns={columns}
          dataSource={data}
          className="ant-border-space"
          style={{ overflowX: "auto" }}
          pagination={true}
        />
      </Card>
      {listeApprenants?.length > 0 && listeModules?.examen?.length > 0  && (
        <ModalSaisieNotes
          openModal={openModal}
          id_affaire={id_affaire}
          setOpenModal={setOpenModal}
          listeApprenants={listeApprenants}
          listeModules={listeModules}
          rattrapage={listeModules?.rattrapage?.length > 0  ? true : false}
        />
      )}
    </div>
  );
};

export default ListeDesExamensEtRattrapages;
